<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_vii"></a><em>Contents</em></h2>
<p class="toc"><a href="#/xhtml/fm01"><em>Preface</em></a></p>
<p class="toc"><a href="#/xhtml/fm02"><em>Abbreviations</em></a></p>
<p class="toc1"><a href="#/xhtml/fm03">Introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01">The Island Division</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec1">Beatons in Portree</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec2">Beatons of Ballenabe</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec3">Beatons in North Uist</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec4">Beatons of Connista</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec5">Beatons in Sleat</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec6">Beatons of Pennycross</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec7">Beatons in South Uist</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec8">Beatons in Kintail</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec9">Beatons of Kilelane</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec10">Beatons in Colonsay</a></p>
<p class="toc_l"><a href="#/xhtml/chapter01#sec11">Beatons in Dervaig</a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">The Mainland Division</span></p>
<p class="toc_l"><span href="#/xhtml/chapter02#sec12" title="Link target outside of Sample">Beatons of Balgillachie</span></p>
<p class="toc_l"><span href="#/xhtml/chapter02#sec13" title="Link target outside of Sample">Beatons of Kildavanan</span></p>
<p class="toc_l"><span href="#/xhtml/chapter02#sec14" title="Link target outside of Sample">Beatons of Melness</span></p>
<p class="toc_l"><span href="#/xhtml/chapter02#sec15" title="Link target outside of Sample">Beatons of Husabost</span></p>
<p class="toc_l"><span href="#/xhtml/chapter02#sec16" title="Link target outside of Sample">Beatons of Culnaskea</span></p>
<p class="toc_l"><span href="#/xhtml/chapter02#sec17" title="Link target outside of Sample">Beatons in Delny</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Other Beaton Medical Families</span></p>
<p class="toc_l"><span href="#/xhtml/chapter03#sec18" title="Link target outside of Sample">Beatons in Kinloid etc.</span></p>
<p class="toc_l"><span href="#/xhtml/chapter03#sec19" title="Link target outside of Sample">Beatons in Glenconvinth</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Status and Landholding</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Medicine and Medical Men</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Schools and Manuscripts</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">The Demise of the Classical Tradition</span></p>
<p class="toc1"><a id="page_viii"></a><span href="#/xhtml/bm01" title="Link target outside of Sample"><em>Appendices</em></span></p>
<table class="tab_tb">
<tbody><tr>
<td><p class="toch"><span href="#/xhtml/bm01" title="Link target outside of Sample">I.</span></p></td>
<td><p class="toch"><span href="#/xhtml/bm01" title="Link target outside of Sample">Beaton Medical Families and Distribution Map</span></p></td>
</tr>
<tr>
<td><p class="toch"><span href="#/xhtml/bm02" title="Link target outside of Sample">II.</span></p></td>
<td><p class="toch"><span href="#/xhtml/bm02" title="Link target outside of Sample">Beaton Physicians c.1300–c.1750</span></p></td>
</tr>
<tr>
<td><p class="toch"><span href="#/xhtml/bm03" title="Link target outside of Sample">III.</span></p></td>
<td><p class="toch"><span href="#/xhtml/bm03" title="Link target outside of Sample">Signatures, Handwriting and Ownership of Manuscripts</span></p></td>
</tr>
<tr>
<td><p class="toch"><span href="#/xhtml/bm04" title="Link target outside of Sample">IV.</span></p></td>
<td><p class="toch"><span href="#/xhtml/bm04" title="Link target outside of Sample">Gaelic Manuscripts associated with Beatons</span></p></td>
</tr>
<tr>
<td><p class="toch"><span href="#/xhtml/bm05" title="Link target outside of Sample">V.</span></p></td>
<td><p class="toch"><span href="#/xhtml/bm05" title="Link target outside of Sample">Ó Conchobhair Physicians in Lorn</span></p></td>
</tr>
<tr>
<td><p class="toch"><span href="#/xhtml/bm06" title="Link target outside of Sample">VI.</span></p></td>
<td><p class="toch"><span href="#/xhtml/bm06" title="Link target outside of Sample">MacPhails in Muckairn</span></p></td>
</tr>
</tbody></table>
<p class="toc1"><span href="#/xhtml/bm07" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?337216a4